module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix workspace",
    attrs: {
      "id": "workspace"
    }
  }, [_c('div', {
    staticClass: "column split-left"
  }, [_c('div', {
    staticClass: "form",
    attrs: {
      "id": "form"
    }
  }, [_vm._t("form")], 2)]), _c('div', {
    staticClass: "column split-right graph-paper"
  }, [_c('div', {
    attrs: {
      "id": "rendered"
    }
  }, [_vm._t("render")], 2)]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "-5000px",
      "left": "-5000px"
    },
    attrs: {
      "id": "clone"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdefbf6a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace.vue
// module id = 233
// module chunks = 0